import React from 'react'
import { Link, Navigate } from 'react-router-dom'
import { AuthForm } from '../../../../components/AuthForm/AuthForm'
import { LoadingForm } from '../../../../components/LoadingForm/LoadingForm'
import { Title } from '../../../../components/Title/Title'
import { ROUTES } from '../../../../constants/routes'
import { useAuth } from '../../../../hooks/useAuth'
import { ForgotPasswordForm } from './components/ForgotPasswordForm'
import { useRequestRecovery } from './hooks/useRequestRecovery'

export const ForgotPassword = (): React.ReactElement => {
  const { isLoading, user } = useAuth()
  const { hasSubmitted, error, handleSubmit } = useRequestRecovery()

  if (isLoading) {
    return (
      <>
        <Title value="Loading..." />
        <AuthForm useProgress={false} error={error}>
          <LoadingForm />
        </AuthForm>
      </>
    )
  }

  if (user) {
    return <Navigate to={ROUTES.DASHBOARD} replace />
  }

  if (hasSubmitted) {
    return (
      <AuthForm useProgress={false} error={error}>
        <Title value="Reset Email Sent" />
        <h4 className="mb-4">Check your email</h4>
        <p className="mb-4">We’ve sent you an email with instructions to reset your password.</p>
        <Link to={ROUTES.LOGIN} className="d-block my-3">
          Return to login
        </Link>
      </AuthForm>
    )
  }

  return (
    <AuthForm useProgress={false} error={error}>
      <Title value="Forgot Password" />
      <ForgotPasswordForm onSubmit={handleSubmit} />
    </AuthForm>
  )
}
